import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import searchRoutes from "./routes/search";
import companyRoutes from "./routes/company";
import productRoutes from "./routes/product";
import userRoutes from "./routes/user";
import resourceRoutes from "./routes/resource";
import resultsRoutes from './routes/result';
import ClientLayout from "@/layouts/clientLayout/index.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: '/exception',
		component: () => import(/* webpackChunkName: "companyAttention" */ '@/layouts/fullScreen/index.vue'),
		children: [
			{
				path: '/exception/comp',
				name: 'exceptionComp',
				component: () => import(/* webpackChunkName: "companyAttention" */ '@/views/exception/comp.vue'),
				meta: {
					title: "企业未开通企业站",
				},
			},
			{
				path: '/exception/vipexpire/:id',
				name: 'exceptionVipexpire',
				component: () => import(/* webpackChunkName: "companyAttention" */ '@/views/exception/vipexpire.vue'),
				meta: {
					title: "企业已下架",
				},
			},
			{
				path: '/exception/productrepeal/:id',
				name: 'exceptionProductrepeal',
				component: () => import(/* webpackChunkName: "companyAttention" */ '@/views/exception/product-repeal.vue'),
				meta: {
					title: "产品已下架",
				},
			}
		]
	},
	{
		path: '/unify-oauth/:source',
		name: 'unifyOauth',
		component: () => import(/* webpackChunkName: "companyAttention" */ '@/views/user/unify-oauth/index.vue'),
		meta: {
		  title: "服务授权",
		},
	},
	{
		path: "/",
		redirect: "/search/home",
		component: ClientLayout,
		children: [
			...searchRoutes,
			...companyRoutes,
			...productRoutes,
			...userRoutes,
			...resourceRoutes,
			...resultsRoutes,
		],
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
